import React from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';

const ModalActaDevolucion = ({ setModalActaDevolucion, validateResult }) => {

    return (
        <div id="act-devolucion-modal" class="c-modal  c-modal--info" aria-labelledby="modal-demo-modal-title">
            <div class="c-modal__wrapper">
                <div class="c-modal__header">
                    <div class="c-modal__title__wrapper">
                        <i class="c-modal__status-icon" aria-hidden="true"></i>
                        <h2 id="modal-demo-modal-title" class="c-modal__title">Info: Devoluciones</h2>
                    </div>
                <button onClick={() => setModalActaDevolucion(false)} class="c-modal__close-btn  js-modal-close" type="button" aria-label="Close this dialog window."></button>
                </div>
                <div class="c-modal__content">
                    {validateResult.messages.map((msg, i) => (
                        <p key={i}>{msg}</p>
                    ))}
                </div>
                <div class="c-modal__footer">
                    <div class="c-modal__actions__container">
                        <div class="c-modal__actions">
                            <div class="c-modal__actions__item  ">

                                <button onClick={() => setModalActaDevolucion(false)} class="c-btn  js-modal-close" type="button">

                                    <span class="c-btn__text">
                                        Aceptar
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default withCookies(withRouter(ModalActaDevolucion));
